import { render, staticRenderFns } from "./ModalDspSearch.vue?vue&type=template&id=6638ad61&"
import script from "./ModalDspSearch.vue?vue&type=script&lang=ts&"
export * from "./ModalDspSearch.vue?vue&type=script&lang=ts&"
import style0 from "./ModalDspSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports